import React from 'react';

interface SVGNormalNextProps {
  width?: string;
  height?: string;
  color?: string;
  strokeWidth?: string;
}

const SVGNormalNext = ({
  width = '22',
  height = '18',
  color = 'white',
  strokeWidth = '2',
}: SVGNormalNextProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 22 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 1L21 9M21 9L13 17M21 9H1"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SVGNormalNext;
